import BreadCrumb from '../../../../Components/Common/BreadCrumb'
import React from 'react'
import { Container, Row } from 'reactstrap'
import Sidepanel from './Sidepanel'
import MainList from './MainList'

const UserGuide = () => {

    document.title = "Guia do Usuário | Plantão Rápido";

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title="Guia do Usuário" pageTitle="Ajuda" />
                    <Row>

                        <MainList />

                        <Sidepanel />

                    </Row>
                </Container>
            </div>
        </React.Fragment>
    )
}

export default UserGuide